// extracted by mini-css-extract-plugin
export var boldText = "_6b-4";
export var checkboxContainer = "_6b-6";
export var closeIcon = "_6b-i";
export var container = "_6b-0";
export var drawer = "_6b-8";
export var drawerContent = "_6b-9";
export var extraSmallText = "_6b-5";
export var fulfillmentGroupTable = "_6b-e";
export var largeText = "_6b-3";
export var loadingSpinnerContainer = "_6b-j";
export var mediumText = "_6b-2";
export var narrow = "_6b-f";
export var notificationLink = "_6b-l";
export var packageCheckIconContainer = "_6b-7";
export var slideoutHeaderActions = "_6b-g";
export var slideoutHeaderActionsShifted = "_6b-h";
export var slideoutHeaderContainer = "_6b-a";
export var slideoutModal = "_6b-c";
export var stickyHeaderWrapper = "_6b-b";
export var table = "_6b-k";
export var tableContainer = "_6b-d";
export var tertiaryText = "_6b-1";